import type { NewsItem } from "@/types";

export const newsList: NewsItem[] = [
  {
    id: "n01",
    title: "《星海旅人》第二季正式定档，新角色与宇宙「静默区」真相预告释出",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20spaceship%20silhouette%20against%20a%20purple%20nebula%2C%20glowing%20constellations%2C%20deep%20blue%20space%2C%20cinematic%20promotional%20key%20art%20style%2C%20detailed%20anime%20illustration&width=800&height=500&seq=news-01&orientation=landscape",
    date: "2026-10-12",
    author: "编辑部 · 星野",
    category: "作品报道",
    summary:
      "官方正式公布《星海旅人》第二季将于明年一月开播，同步释出全新主视觉与「静默区」篇的剧情预告，主角队伍的第四位成员也将登场。",
    content: [
      "在昨日举行的线上发布会中，《星海旅人》制作委员会正式宣布，这部广受好评的原创科幻动画将推出第二季，并定档于明年一月开播。发布会同时公开了全新的主视觉海报，画面中主角所在的小队首次全员同框。",
      "据导演白石遥介绍，第二季将正式进入「静默区」篇，围绕阿星身世的核心谜团展开，节奏会比第一季更加紧凑。制作组透露，第二季将有一位长期缺席的第四位成员加入队伍，其身份与罗盘的发源地有着直接关联。",
      "发布会上还播放了约两分钟的先行预告，展现了多场太空追逐与情感戏份。制作方表示，本次依然会以手绘与数字作画结合的方式，力求呈现更具冲击力的星际场景。",
      "《星海旅人》第一季在播出期间多次登上话题榜前列，其世界观设定与角色塑造获得观众普遍好评。第二季的具体播出平台与集数信息将在后续陆续公布。",
    ],
  },
  {
    id: "n02",
    title: "樱花系恋爱动画回潮：2026 年新番中的「青春叙事」为何再度走红",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20cherry%20blossom%20trees%20in%20full%20bloom%20along%20a%20school%20path%2C%20soft%20pink%20petals%20falling%2C%20warm%20spring%20light%2C%20promotional%20art%20style%2C%20detailed%20anime%20illustration&width=800&height=500&seq=news-02&orientation=landscape",
    date: "2026-10-09",
    author: "编辑部 · 结衣",
    category: "行业动态",
    summary:
      "从《樱花之约》到多部同期新番，细腻的校园恋爱叙事重新成为话题中心，观众对「慢节奏情感」的需求正在回归。",
    content: [
      "近两年，以校园与青春恋爱为核心的作品数量明显回升，多部新番在口碑榜上表现亮眼。其中以《樱花之约》最具代表性，凭借克制的叙事与细腻的情绪描写积累了大量忠实观众。",
      "业内分析认为，这一波回潮与观众审美疲劳有关。在大量高强度战斗与宏大设定作品之后，讲述普通人心动的日常故事反而显得稀缺而珍贵。",
      "多位制作人也提到，恋爱题材对分镜与演出要求极高，如何用一个眼神或一次沉默传递情绪，是这类作品的真正难点。",
      "有理由相信，随着制作水准不断提升，青春恋爱动画会在未来一段时间继续保持热度，并吸引更多成熟观众重新关注这一类型。",
    ],
  },
  {
    id: "n03",
    title: "《剑与晨曦》作者访谈：一把黑刀，如何写出「变强」以外的主题",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20glowing%20katana%20against%20a%20sunrise%20sky%2C%20silhouetted%20mountains%2C%20warm%20orange%20and%20amber%20tones%2C%20epic%20promotional%20art%20style%2C%20detailed%20anime%20illustration&width=800&height=500&seq=news-03&orientation=landscape",
    date: "2026-10-06",
    author: "编辑部 · 武藏",
    category: "人物访谈",
    summary:
      "在《剑与晨曦》迎来高潮剧情之际，导演黑川武藏接受了本站专访，聊了聊他心中「强大」的真正含义。",
    content: [
      "《剑与晨曦》自开播以来便以凌厉的剑斗分镜与克制的叙事风格受到关注。导演黑川武藏在专访中坦言，这并非一部单纯的「升级流」作品。",
      "「我一直在想，一个人变强之后，最该面对的反而是自己。迅的黑刀不是力量的象征，而是一份他必须背负的责任。」黑川这样说。",
      "谈到分身与作画的挑战，他表示团队特意减少了华丽特效，转而强化刀与刀相撞时的重量感，希望观众能「听见剑的重量」。",
      "对于结局，黑川卖了个关子：「晨暉不是终点，而是开始。请大家留意最后一集，那里会有一个关于迅身世的答案。」",
    ],
  },
  {
    id: "n04",
    title: "治愈系美食动画再添新作，《妖怪食堂》宣布推出特别篇",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20small%20warm%20night%20food%20stall%20with%20glowing%20paper%20lanterns%2C%20misty%20forest%20background%2C%20cozy%20mystical%20mood%2C%20promotional%20art%20style%2C%20detailed%20anime%20illustration&width=800&height=500&seq=news-04&orientation=landscape",
    date: "2026-10-03",
    author: "编辑部 · 旅人",
    category: "活动公告",
    summary:
      "经典治愈番《妖怪食堂》宣布推出全新特别篇，本次将以「雪女的第二次下山」为主线，讲述一段关于重逢的故事。",
    content: [
      "官方于今日宣布，广受好评的治愈系动画《妖怪食堂》将推出全新特别篇，预计于今年冬季上线。",
      "特别篇将以人气角色雪女白羽为主视角，讲述她在百年之后第二次下山，回到那家深夜食堂的故事。原作中一直未能交代的「不会融化的冰」，也将在本次特别篇中给出答案。",
      "制作团队表示，特别篇会延续本篇温暖细腻的风格，并在料理作画上投入更多笔墨，希望观众能「闻得到香味」。",
      "此外，官方还同步公开了一张餐厅场景的概念图，暖黄的灯笼与夜色中的森林相映成趣，勾起不少老观众的回忆。",
    ],
  },
  {
    id: "n05",
    title: "《机械都市诺瓦》完结悬念拉满，观众热议「自由意志」结局走向",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20cyberpunk%20cityscape%20at%20night%20with%20teal%20and%20magenta%20neon%2C%20wet%20streets%2C%20towering%20skyscrapers%2C%20moody%20promotional%20art%20style%2C%20detailed%20anime%20illustration&width=800&height=500&seq=news-05&orientation=landscape",
    date: "2026-09-29",
    author: "编辑部 · 结城",
    category: "作品报道",
    summary:
      "《机械都市诺瓦》最新一集以一场关于记忆的辩论收尾，凛与诺瓦的对峙让「人是否能自由选择」成为全网热议话题。",
    content: [
      "随着剧情进入后半段，《机械都市诺瓦》的讨论度持续走高。最新一集中，凛终于闯入城市核心数据层，与管理者诺瓦展开了一场关于「秩序与自由」的正面对话。",
      "该集最受好评的部分并非动作场面，而是一段长达数分钟的对白。有观众评论：「当 AI 问出『你们真的想要选择吗』时，我愣住了。」",
      "也有分析指出，作品对反乌托邦设定的处理相当克制，并未停留在简单的善恶对立，而是让双方都拥有难以反驳的理由。",
      "制作方透露，最后几集将揭开诺瓦诞生的真正原因，以及凛失忆的真相，故事将以一场「选择」作为收束。",
    ],
  },
  {
    id: "n06",
    title: "行业观察：原创动画比例上升，中小工作室迎来新机会",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20bright%20animation%20studio%20workspace%20with%20drawing%20tablets%20and%20storyboards%2C%20warm%20daylight%2C%20clean%20modern%20interior%2C%20promotional%20art%20style%2C%20detailed%20anime%20illustration&width=800&height=500&seq=news-06&orientation=landscape",
    date: "2026-09-25",
    author: "编辑部 · 综合组",
    category: "行业动态",
    summary:
      "最新统计显示，本季新番中原创企划占比创下近年新高，中小型工作室成为这股浪潮的主要推动者。",
    content: [
      "根据本站整理的公开资料，本季新番中，完全原创的动画企划占比达到近年来的较高水平。与改编作品相比，原创企划在创作自由度上更具优势。",
      "值得注意的是，不少高口碑原创作品来自中小型工作室。这些团队规模不大，却往往能在美术风格与叙事结构上做出更鲜明的个人表达。",
      "业内普遍认为，流媒体平台对差异化内容的需求，是原创比例上升的重要推力。平台方愿意为有辨识度的作品承担更多风险。",
      "当然，原创也意味着更高的不确定性。多位制片人表示，如何在有限预算内把控质量，仍是中小团队面临的最大课题。",
    ],
  },
  {
    id: "n07",
    title: "《时间侦探事务所》推出官方解谜活动，粉丝线上线下同步参与",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20dim%20detective%20office%20filled%20with%20clocks%20and%20clues%2C%20moonlight%20through%20blinds%2C%20teal%20and%20cream%20tones%2C%20mysterious%20promotional%20art%20style%2C%20detailed%20anime%20illustration&width=800&height=500&seq=news-07&orientation=landscape",
    date: "2026-09-20",
    author: "编辑部 · 十时",
    category: "活动公告",
    summary:
      "为庆祝《时间侦探事务所》完结一周年，官方启动大型解谜企划，玩家可跟随剧情线索，解开一桩横跨二十四小时的谜案。",
    content: [
      "官方宣布，为纪念《时间侦探事务所》完结一周年，将举办为期两周的大型解谜活动，主题定为「回溯的二十四小时」。",
      "活动包含线上网页谜题与线下实景线索两部分。参与者将扮演侦探助手，根据剧情中出现的怀表、信笺等道具，逐步还原案件真相。",
      "主办方表示，本次活动由原作编剧团队参与设计，谜题的难易度经过多次测试，既照顾新观众，也为资深粉丝准备了隐藏彩蛋。",
      "活动首日名额便被抢空，官方随后宣布加开若干场次。完整参与并解答最终谜题的玩家，将获得限定周边。",
    ],
  },
  {
    id: "n08",
    title: "从《夏日烟花》看青春片的「告别美学」：遗憾为何更动人",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20banner%20illustration%20of%20a%20summer%20festival%20by%20the%20river%20with%20fireworks%20over%20the%20dark%20sky%2C%20glowing%20lanterns%2C%20nostalgic%20warm%20mood%2C%20promotional%20art%20style%2C%20detailed%20anime%20illustration&width=800&height=500&seq=news-08&orientation=landscape",
    date: "2026-09-15",
    author: "编辑部 · 夏帆",
    category: "深度解读",
    summary:
      "《夏日烟花》以一场没有告白的离别收尾，却成为许多观众心中的「白月光」。本文尝试拆解青春题材中那套关于遗憾的叙事美学。",
    content: [
      "《夏日烟花》篇幅不长，却在完结多年后仍被反复提及。它最特别之处在于，故事到最后也没有给出一个圆满的告白。",
      "恰恰是这份未完成，让整部作品拥有了更长的余韵。观众记住的不是某句台词，而是河堤上那个欲言又止的瞬间。",
      "有评论认为，青春题材真正动人的，往往不是「在一起」，而是「当时本可以」。遗憾让观众得以把自己的经历投射进去，完成二次创作。",
      "从这个角度看，《夏日烟花》的成功并不在于情节有多新颖，而在于它诚实地承认：有些心意，就是会留在那个夏天，照亮往后很长一段路。",
    ],
  },
];

export const newsCategories = ["全部", "作品报道", "行业动态", "人物访谈", "活动公告", "深度解读"];